export enum NotificationChannel_Enum{
    OptOut = 0,
    Push = 1,
    Email = 2,
    SMS = 3,
    WhatsApp = 4
}